import * as React from 'react'

const Team = () => {
    return(
        <div id="contato" className="container-fluid contact-f-block col-sm-12 text-center">
        <p className="extra-large-text bold s-margin text-center roxo-e">CONTATO</p>
            <h1>Qual sua ideia?</h1>
            <h4>Nós adorariamos ouví-la e conectá-la</h4>
            <img src={require("../css/img/cafe.png")} alt=""/>
            <h1><a href="mailto:hello@syligo.com">hello@syligo.com</a></h1>

            <h4>Siga-nos:</h4>

            <a href="https://www.linkedin.com/company/syligo/" target="_blank"><i className="fab fa-linkedin-in fa-2x icon roxo-e"></i></a>
            <a href="https://medium.com/@syligohealth" target="_blank"><i className="fab fa-medium-m icon fa-2x roxo-e"></i></a>
            <a href="https://twitter.com/syligo" target="_blank"><i className="fab fa-twitter icon fa-2x roxo-e"></i></a>
            <a href="https://www.facebook.com/Syligo/" target="_blank"><i className="fab fa-facebook-f icon fa-2x roxo-e"></i></a>
        </div>
    );
};
export default Team;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ContactComponent.tsx